import { differenceInDays, now, OwaDate, startOfDay } from 'owa-datetime';

export default function (dueDate: OwaDate, referenceDate: OwaDate = now()): boolean {
    return differenceInDays(startOfDay(referenceDate), startOfDay(dueDate)) > 0;
}
